export default __webpack_public_path__ + "static/media/pdfImage.acfa79c7.svg";